import { Modal, useModalsStack } from '@mantine/core';
import { BuyButton } from '../BuyButton';
import { AddPaymentModal } from './AddPaymentModal';
import { BuyCryptoModal } from './BuyCryptoModal';
import { ProcessingModal } from './ProcessingModal';
import { SuccessModal } from './SuccessModal';
export type BuyCryptoModalType = ReturnType<typeof useModalsStack<'buy-crypto' | 'processing' | 'success' | 'add-payment'>>;
export const DepositBuyCryptoModal: React.FC = () => {
  const stack = useModalsStack(['buy-crypto', 'processing', 'success', 'add-payment']);
  return <>
      <Modal.Stack>
        <BuyCryptoModal stack={stack} />

        <ProcessingModal stack={stack} />

        <SuccessModal stack={stack} />

        <AddPaymentModal stack={stack} />
      </Modal.Stack>

      <BuyButton handleClick={() => stack.open('buy-crypto')} />
    </>;
};